import { Alert, Button, Snackbar, Stack } from "@mui/material";

const CustomSnackbar = ({
  open,
  onClose,
  vertical = "top",
  horizontal = "center",
  title = "",
  handleConfirm,
}) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      key={horizontal + vertical}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert severity="warning" sx={{ width: "100%", marginTop: "10rem" }}>
        {title}
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-around",
            padding: 1,
          }}
        >
          <Button
            size="small"
            onClick={onClose}
            color="error"
            variant="contained"
          >
            Cancel
          </Button>
          <Button size="small" onClick={handleConfirm} variant="contained">
            Confirm
          </Button>
        </Stack>
      </Alert>
    </Snackbar>
  );
};
export default CustomSnackbar;
